// Material UI Tabs only accepts a tab as an acceptable child
import { Tab } from 'material-ui/Tabs';

export default Tab;
